var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.toast.show)?_c('div',{staticClass:"toast",style:(_vm.toastPosition)},[_c('span',[_vm._v(_vm._s(_vm.toast.text))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }